module.exports = __webpack_public_path__ + "static/img/list_index.09a89c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/comMenu/images/list_index.png
// module id = zoyV
// module chunks = 11